import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button/Button';
import styles from './NotFound.module.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles['not-found']}>
      <h1 className={styles['not-found-code']}>404</h1>
      <h2 className={styles['not-found-title']}>Página não encontrada</h2>
      <p className={styles['not-found-text']}>
        A página que você está procurando não existe.
      </p>
      <Button variant="primary" size="medium" icon="arrow_back" onClick={() => navigate('/')}>
        Voltar ao Home
      </Button>
    </div>
  );
};

export default NotFound;
